import {ISkillState,IEmployeeSkillsActionCreator,IEmployeeSkillActionTypes} from 'models/IEmployeeSkillsState';

const initialState:ISkillState[] = []

const reducer = (state = initialState, { type, payload }: IEmployeeSkillsActionCreator) => {
    switch (type) {
      case IEmployeeSkillActionTypes.FETCH_EMPLOYEE_SKILLS_REQUEST:
        return {
          ...state,
          data:[],
        }
      case IEmployeeSkillActionTypes.FETCH_EMPLOYEE_SKILLS_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;